/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_Sponsor_TitleInputs */



/**
* | output |
* | --- |
* | "Sponsorship" |
*
* @param {User_List_Filter_Sponsor_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_sponsor_title = /** @type {((inputs?: User_List_Filter_Sponsor_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_Sponsor_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocínio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsorizzazione")
	return /** @type {LocalizedString} */ ("Sponsorship")
});